import React from 'react';
import {
  DividerInputElementClass,
  ElementProps,
} from '../../../types/documentTemplateElement';
import DividerInput from '../../inputs/DividerInput';

interface DividerInputElementProps
  extends ElementProps<DividerInputElementClass> {}

const DividerInputElementComponent: React.FC<
  DividerInputElementProps
> = ({}) => {
  return (
    <>
      <DividerInput />
    </>
  );
};

export default DividerInputElementComponent;
